var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgNewVersion(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "edit-icon",
    transform: "translate(-2263 -1600)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1668",
    "data-name": "Rectangle 1668",
    width: 24,
    height: 24,
    transform: "translate(2263 1600)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    id: "noun_create_1887007",
    d: "M19.28,2.5H8.4A2.228,2.228,0,0,0,6.18,4.72V6.18H4.72A2.228,2.228,0,0,0,2.5,8.4V19.3a2.228,2.228,0,0,0,2.22,2.22H15.6a2.228,2.228,0,0,0,2.22-2.22V17.84h1.46a2.228,2.228,0,0,0,2.22-2.22V4.72A2.228,2.228,0,0,0,19.28,2.5Zm-8.3,15.36a.811.811,0,0,1-.82.82.819.819,0,0,1-.82-.82v-3.2H6.14a.819.819,0,0,1-.82-.82.811.811,0,0,1,.82-.82h3.2V9.82a.82.82,0,1,1,1.64,0v3.2h3.2a.82.82,0,0,1,0,1.64h-3.2Zm8.88-2.26a.58.58,0,0,1-.58.58H17.82V8.4A2.228,2.228,0,0,0,15.6,6.18H7.8V4.72a.58.58,0,0,1,.58-.58h10.9a.58.58,0,0,1,.58.58Z",
    transform: "translate(2263 1599.99)"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNewVersion);
export default __webpack_public_path__ + "static/media/new-version.465221aa5aa6759ee7748b16038189f1.svg";
export { ForwardRef as ReactComponent };